import * as types from './mutation-types'
import axios from 'axios'
import cmnConst from '@/assets/js/constant.js'

const uri = `${cmnConst.API_URL}/api/v3/pet/`
const petVoiceUri = `${cmnConst.API_URL}/api/v3/user/family/petvoice/`

export default {
	namespaced: true,

	state: {
		petWeatherData: null,
		petWalkingSummaryData: null,
		petWalkingHistoryData: null,
		petSummaryData: null,
		petInfoData: null
	},

	mutations: {
		[types.SET_PET_WEATHER_DATA] (state, petWeatherData) {
			state.petWeatherData = petWeatherData
		},
		[types.SET_PET_WALKING_SUMMARY_DATA] (state, petWalkingSummaryData) {
			state.petWalkingSummaryData = petWalkingSummaryData
		},
		[types.SET_PET_WALKING_HISTORY_DATA] (state, petWalkingHistoryData) {
			state.petWalkingHistoryData = petWalkingHistoryData
		},
		[types.SET_PET_SUMMARY_DATA] (state, petSummaryData) {
			state.petSummaryData = petSummaryData
		},
		[types.SET_PET_INFO_DATA] (state, petInfoData) {
			state.petInfoData = petInfoData
		}
	},

	actions: {
		// ペット天気予報を取得するAPI
		[types.SET_PET_WEATHER_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'get',
					url: `${uri}walkingindex.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_PET_WEATHER_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_PET_WEATHER_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_PET_WEATHER_DATA, null)
					reject(error)
				})
			})
		},
		// ペット散歩サマリーを取得するAPI
		[types.SET_PET_WALKING_SUMMARY_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${petVoiceUri}walking/summary.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						pet_id: payload.pet_id,
						from_date: payload.from_date,	// 日、週、月表示は必須、年表示はなし
						to_date: payload.to_date,	// 日、週、月表示は必須、年表示はなし
						year: payload.year	// 日、週、月表示はなし、年表示は必須
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_PET_WALKING_SUMMARY_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_PET_WALKING_SUMMARY_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_PET_WALKING_SUMMARY_DATA, null)
					reject(error)
				})
			})
		},
		// ペット散歩履歴を取得するAPI
		[types.SET_PET_WALKING_HISTORY_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${petVoiceUri}walking/history.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						pet_id: payload.pet_id,
						date: payload.date
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_PET_WALKING_HISTORY_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_PET_WALKING_HISTORY_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_PET_WALKING_HISTORY_DATA, null)
					reject(error)
				})
			})
		},
		// ペット情報サマリーを取得するAPI（1:直腸温(推定), 2:休息量, 3:活動量, 4:食事, 5:毛繕い, 6:水飲み, 7:排泄姿勢, 8:安静時呼吸数）
		[types.SET_PET_SUMMARY_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${petVoiceUri}summary.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						pet_id: payload.pet_id,
						from_date: payload.from_date,	// 日、週、月表示は必須、年表示はなし
						to_date: payload.to_date,	// 日、週、月表示は必須、年表示はなし
						year: payload.year,	// 日、週、月表示はなし、年表示は必須
						action_id: payload.action_id // 1:直腸温(推定), 2:休息量, 3:活動量, 4:食事, 5:毛繕い, 6:水飲み, 7:排泄姿勢, 8:安静時呼吸数
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_PET_SUMMARY_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_PET_SUMMARY_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_PET_SUMMARY_DATA, null)
					reject(error)
				})
			})
		},
		// ペット情報を取得するAPI
		[types.SET_PET_INFO_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'post',
					url: `${petVoiceUri}info.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						pet_id: payload.pet_id,
						date: payload.date
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_PET_INFO_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_PET_INFO_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_PET_INFO_DATA, null)
					reject(error)
				})
			})
		}
	},

	getters: {
		petWeatherData (state) {
			return state.petWeatherData
		},
		petWalkingSummaryData (state) {
			return state.petWalkingSummaryData
		},
		petWalkingHistoryData (state) {
			return state.petWalkingHistoryData
		},
		petSummaryData (state) {
			return state.petSummaryData
		},
		petInfoData (state) {
			return state.petInfoData
		}
	}
}
